const NimbusErrors = {
  INVALID_GOOGLE_TOKEN: 'Invalid google token',
  INVALID_ITERNAL_USER: 'Only @pando.in email ids are supported',
  GOOGLE_TOKEN_MAY_BE_EXPIRED: 'Google OAuth2 token might have been expired',
  EMAIL_MISSING: 'EMAIL',
  EMAIL_NOT_VERIFIED: 'EMAIL_VERIFICATION_FAILED',
  NAME_MISSING: 'NAME',
  PICTURE_MISSING: 'PICTURE',
  DATA_MISSING: 'data',
  PASSWORD_MISSING: 'Password is missing',
};

const NIMBUS_ENTITIES = {
  SHIPPER: 1,
  FF: 2,
  USERS: 3,
};

const NIMBUS_UPDATES = {
  UPDATE_FEATURES: 1,
  UPDATE_PERMISSIONS: 2,
  UPDATE_CLIENT_CONFIGURATIONS: 3,
  UPDATE_DEPOT_CONFIGURATIONS: 4,
  UPDATE_USER_PERMISSION: 5,
  CLONE_ROLE: 6,
};

const PANDO_CLIENT_ID = '5eccb87dc6c3a23810397ebf';

const NIMBUS_INTERNAL_DEFAULT_PASSWORD = 'test@1234';


const NIMBUS_INTERNAL_ROLES = {
  ADMIN: 'admin',
  USER: 'user',
};

const INTERNAL_USER_STATUS = {
  ACTIVE: 1,
  INVACTIVE: 2,
};

const defaultUserPermissions = { viewPermission: true, editPermission: false };
const nimbusSuperAdminPermissions = { viewPermission: true, editPermission: true };
const nimbusUnauthenticatedRoutes = ['/api/login', '/api/google-login'];
const NIMBUS_DEFAULT_DESC = 'This is a default description';

module.exports = {
  NimbusErrors,
  PANDO_CLIENT_ID,
  NIMBUS_INTERNAL_DEFAULT_PASSWORD,
  NIMBUS_INTERNAL_ROLES,
  INTERNAL_USER_STATUS,
  defaultUserPermissions,
  nimbusSuperAdminPermissions,
  nimbusUnauthenticatedRoutes,
  NIMBUS_DEFAULT_DESC,
  NIMBUS_ENTITIES,
  NIMBUS_UPDATES,
};
